import React, { useContext } from 'react';
import { Sacola } from '../Sacola';
import './styles.css';
import { ProdutosCategoria } from '../ProdutosCategoria';
import { Shimmer } from '../Shimmer';
import useWindowDimensions from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';

export const ListaProdutos = React.memo(function ListaProdutos() {
  const { dadosApp } = useContext(GlobalContext);
  const { width } = useWindowDimensions();
  const [prodList, setProdList] = React.useState(dadosApp.Cardapio.Produtos);

  const handleItensMultBloqueados = React.useCallback(() => {
    // Pega uma lista dos produtos bloqueados
    const productsBloqueados = dadosApp.Cardapio.Produtos?.filter(
      (produto) => produto.is_principal_multpreco && produto.bloqueado === 1,
    );

    if (!productsBloqueados || productsBloqueados.length === 0) return setProdList(dadosApp.Cardapio.Produtos);

    // Copiar a lista de produtos
    let updatedProdutos = [...dadosApp.Cardapio.Produtos];

    // Iterar sobre os produtos bloqueados
    productsBloqueados.forEach((prodBloq) => {
      const itensMult = dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_principal === prodBloq.codigo);

      itensMult.forEach((prodMult) => {
        updatedProdutos = updatedProdutos.map((produto) => {
          // Verificar as condições para alterar as flags

          const _isPrincipalMult = produto.is_principal_multpreco && produto.codigo === prodMult.codigo_mult;
          const _isSubitemMult = produto.is_subitem_multpreco && produto.codigo === prodMult.codigo_mult;

          if (_isPrincipalMult || _isSubitemMult) {
            // Retornar o produto com as flags atualizadas

            return {
              ...produto,
              is_principal_multpreco: _isPrincipalMult ? false : produto.is_principal_multpreco,
              is_subitem_multpreco: _isSubitemMult ? false : produto.is_subitem_multpreco,
            };
          }

          // Retornar o produto sem alterações
          return produto;
        });
      });
    });

    setProdList(updatedProdutos);
  }, [dadosApp.Cardapio.MultPreco, dadosApp.Cardapio.Produtos]);

  React.useEffect(() => {
    handleItensMultBloqueados();
  }, [handleItensMultBloqueados]);

  return (
    <>
      <div className="container margin_detail">
        <div className="row">
          <div className={`${dadosApp.Qs.cardapioDigital === 'true' ? 'col-lg-6' : 'col-lg-8'}`}>
            {dadosApp.Cardapio.Categorias.length == 0 ? <Shimmer type="Produtos" /> : ''}
            {dadosApp.Cardapio.Categorias.sort((ordem) => ordem.ordem_app).map((categoria, index) => {
              const _categoria =
                categoria.categoria_ecommerce === '' ? categoria.subgrupo : categoria.categoria_ecommerce;

              //const _productList = dadosApp.Cardapio.Produtos?.filter((produto) => {
              const _productList = prodList?.filter((produto) => {
                if (categoria.categoria_ecommerce !== '') {
                  return (
                    produto.categoria_ecommerce === categoria.categoria_ecommerce && // ERRADO ??????????
                    produto.is_subitem_multpreco === false // regra para os multi preços
                  );
                } else {
                  return produto.subgrupo === categoria.subgrupo && produto.is_subitem_multpreco === false; // regra para os multi preços
                }
              });

              // correção de categorias sem produtos
              if (_productList?.length > 0) {
                return (
                  <section key={_categoria} id={_categoria?.toUpperCase()?.trim()} className="page-section">
                    <ProdutosCategoria key={index} categoria={categoria} produtos={_productList} />
                  </section>
                );
              }
            })}
          </div>

          {width > 991 && dadosApp.Cardapio.Categorias.length > 0 && dadosApp.Qs.cardapioDigital !== 'true' && (
            <Sacola
              param={{
                origin: 'desktop',
              }}
            />
          )}
        </div>
      </div>
    </>
  );
});
